// extracted by mini-css-extract-plugin
module.exports = {"rating":"ratings_rating__200YN","label":"ratings_label__17n9X"};